export default __webpack_public_path__ + "static/media/availableDataset.e6caa128.png";